export const APP_VERSION_STORAGE_KEY = "genesis_app_version";

const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function getStoredAppVersion() {
    try {
        return localStorage.getItem(APP_VERSION_STORAGE_KEY) || "";
    } catch {
        return "";
    }
}

export function setStoredAppVersion(version) {
    try {
        localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
    } catch {
        // Ignore storage failures in private browsing or restricted contexts.
    }
}

export async function fetchLatestAppVersion() {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: "no-store",
        headers: {
            "Cache-Control": "no-cache",
        },
    });

    if (!response.ok) {
        throw new Error("Unable to fetch app version.");
    }

    const payload = await response.json();
    return payload.version || "";
}

export async function checkForAppUpdate({ reload = true } = {}) {
    try {
        const latestVersion = await fetchLatestAppVersion();
        if (!latestVersion) {
            return { updated: false, version: getStoredAppVersion() };
        }

        const storedVersion = getStoredAppVersion();

        if (!storedVersion) {
            setStoredAppVersion(latestVersion);
            return { updated: false, version: latestVersion };
        }

        if (storedVersion !== latestVersion) {
            setStoredAppVersion(latestVersion);
            if (reload) {
                window.location.reload();
            }
            return { updated: true, version: latestVersion };
        }

        return { updated: false, version: latestVersion };
    } catch {
        return { updated: false, version: getStoredAppVersion() };
    }
}

export function initAppVersionCheck() {
    checkForAppUpdate();

    const intervalId = window.setInterval(() => {
        checkForAppUpdate();
    }, VERSION_CHECK_INTERVAL_MS);

    const handleFocus = () => {
        checkForAppUpdate();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
        window.clearInterval(intervalId);
        window.removeEventListener("focus", handleFocus);
    };
}
